import { v4 as uuid } from "uuid";
import { OrganisationLineItem } from "./organisation";

import * as EntityProfile from "../entities/profile";
import { UserLineItem } from "./user";
export type Profile = EntityProfile.Profile;

export enum ProfileType {
  Admin = "profile-type_admin",
  Standard = "profile-type_standard",
}

export const profileTypeToString = (profileType: ProfileType): string => {
  switch (profileType) {
    case ProfileType.Admin:
      return "Admin";
    case ProfileType.Standard:
      return "Standard";
  }
};

export enum ProfileStatus {
  Active = "profile-status_active",
  Invited = "profile-status_invited",
}

export const profileStatusToString = (profileStatus: ProfileStatus): string => {
  switch (profileStatus) {
    case ProfileStatus.Active:
      return "Active";
    case ProfileStatus.Invited:
      return "Invited";
  }
};

export type ProfileLineItem = {
  id: string;
  organisationId: string;
  name: string;
  email: string;
  emailNotifications: boolean;
  status: ProfileStatus;
  type: ProfileType;
  created: Date;
};

export const createDefaultProfile = (
  organisation?: OrganisationLineItem,
  user?: UserLineItem
): ProfileLineItem => {
  return {
    id: user ? user.id : uuid(),
    organisationId: organisation ? organisation.id : uuid(),
    name: "",
    email: user ? user.email : "",
    emailNotifications: false,
    type: ProfileType.Standard,
    status: ProfileStatus.Active,
    created: new Date(),
  };
};

export const createInvite = (email: string): ProfileLineItem => {
  return {
    id: uuid(),
    organisationId: "",
    name: "",
    email: email,
    emailNotifications: false,
    type: ProfileType.Standard,
    status: ProfileStatus.Invited,
    created: new Date(),
  };
};

export const NO_ORGANISATION_ID = "NO-ORGANISATION-ID";
